module.exports = __webpack_public_path__ + "img/040-feedback.0504a8a7.png";